'use client';

import { useLocale } from 'next-intl';
import { useState } from 'react';

import { useUserLocalization } from '@/hooks/useUserLocalization';
import { SimpleLocationDto } from '@/lib/locations/dto';
import { getNearestLocations } from '@/lib/locations/get-nearest-locations';

import { BackgroundColors } from '../types';
import { LocationCardsWithMap } from './LocationCardsWithMap';

type NearbyLocationsModuleProps = {
  title?: string;
  backgroundColor?: BackgroundColors;
  mapboxAccessToken: string;
  slugs?: string[];
  cardsListContainerClassName?: string;
  mapHidden?: boolean;
  allLocationsLinkLabel?: string;
};

export default function NearbyLocationsModule({
  title,
  backgroundColor,
  mapboxAccessToken,
  slugs,
  cardsListContainerClassName,
  mapHidden,
  allLocationsLinkLabel,
}: NearbyLocationsModuleProps) {
  const [isLoading, setLoading] = useState(true);
  const locale = useLocale();
  const [nearbyLocations, setNearbyLocations] = useState<SimpleLocationDto[]>(
    []
  );

  useUserLocalization({
    onUserLocalizationChange: async ({ lnglat }) => {
      const nearestLocations = await getNearestLocations({
        locale,
        slugs,
        limit: 2,
        longitude: lnglat.lng,
        latitude: lnglat.lat,
      });

      setLoading(false);

      if (nearestLocations) {
        setNearbyLocations(nearestLocations);
      }
    },
  });

  if (!isLoading && nearbyLocations.length === 0) {
    return null;
  }

  return (
    <LocationCardsWithMap
      title={title}
      isLoading={isLoading}
      locations={nearbyLocations}
      backgroundColor={backgroundColor}
      mapboxAccessToken={mapboxAccessToken}
      cardsListContainerClassName={cardsListContainerClassName}
      mapHidden={mapHidden}
      allLocationsLinkLabel={allLocationsLinkLabel}
    />
  );
}
